import type { ApolloCache } from "@apollo/client/cache"

import { comparePosition } from "shared/lib/sorting/comparePosition"
import { ProjectChild, ProjectParentTypename } from "shared/types/Project"

import { getProjectChildren } from "entities/project-children/lib/getProjectChildren"

import { updateProjectChildren } from "./updateProjectChildren"

export function updateProjectChildrenSorting({
  movedChild,
  prevParentID,
  prevParentType,
  nextParentID,
  nextParentType,
  cache
}: {
  movedChild: ProjectChild
  prevParentID: string
  prevParentType: ProjectParentTypename
  nextParentID: string
  nextParentType: ProjectParentTypename
  cache: ApolloCache<object>
}) {
  const prevParentChildren: ProjectChild[] =
    getProjectChildren(prevParentID, prevParentType, cache) || []

  const updatedPrevParentChildren: ProjectChild[] = [...prevParentChildren]
    .filter(child => child.id !== movedChild?.id)
    .sort(comparePosition)
    .map((child, index) => ({
      ...child,
      position: index
    }))

  updateProjectChildren({
    parentID: prevParentID,
    parentType: prevParentType,
    children: updatedPrevParentChildren,
    cache
  })

  const nextParentChildren: ProjectChild[] =
    getProjectChildren(nextParentID, nextParentType, cache) || []

  let updatedNextParentChildren = [...nextParentChildren]

  if (movedChild?.position !== undefined) {
    updatedNextParentChildren?.splice(movedChild.position || 0, 0, movedChild)
  }
  updatedNextParentChildren = updatedNextParentChildren.map((child, index) => ({
    ...child,
    position: index
  }))

  updateProjectChildren({
    parentID: nextParentID,
    parentType: nextParentType,
    children: updatedNextParentChildren,
    cache
  })
}
